import Box from '../../src/legacy/Box.tsx';
export default Box;
